import { render, staticRenderFns } from "./ManageTeachLearn.vue?vue&type=template&id=d489d7fa&"
import script from "./ManageTeachLearn.vue?vue&type=script&lang=js&"
export * from "./ManageTeachLearn.vue?vue&type=script&lang=js&"
import style0 from "./ManageTeachLearn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports